import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const permissionRouter: Array<RouteRecordRaw> = [
    {
        path: '/permission',
        name: '权限管理',
        component: Layout,
        meta: { title: '权限管理', icon: 'icon-permission', alwaysShow: true },
        children: [
            {
                path: 'user/list',
                name: '用户列表',
                component: () => import('@/views/permission/User.vue'),
                meta: { title: '用户列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'user/edit',
                name: '用户编辑',
                component: () => import('@/views/permission/UserEdit.vue'),
                meta: { title: '用户编辑', hidden: true, depth: 40 },
            },
            {
                path: 'user/shop-user',
                name: '门店账号',
                component: () => import('@/views/permission/ShopUser.vue'),
                meta: { title: '门店账号', keepAlive: true, depth: 30 }
            },
            {
                path: 'user/shop-user-confirm',
                name: '门店账号确认',
                component: () => import('@/views/permission/ShopUserConfirm.vue'),
                meta: { title: '门店账号确认' }
            },
            {
                path: 'role/list',
                name: '角色列表',
                component: () => import('@/views/permission/Role.vue'),
                meta: { title: '角色列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'role/edit',
                name: '角色编辑',
                component: () => import('@/views/permission/RoleEdit.vue'),
                meta: { title: '角色编辑', hidden: true },
            }
            // {
            //     path: 'user',
            //     name: '用户管理',
            //     component: () => import('@/views/permission/Index.vue'),
            //     meta: { title: '用户管理', hidden: true },
            //     children: [
            //         {
            //             path: 'list',
            //             name: '用户列表',
            //             component: () => import('@/views/permission/User.vue'),
            //             meta: { title: '用户列表', keepAlive: true, depth: 30}
            //         },
            //         {
            //             path: 'edit',
            //             name: '用户编辑',
            //             component: () => import('@/views/permission/UserEdit.vue'),
            //             meta: { title: '用户编辑', hidden: true },
            //         },
            //         {
            //             path: 'shop-user',
            //             name: '门店账号',
            //             component: () => import('@/views/permission/ShopUser.vue'),
            //             meta: { title: '门店账号' }
            //         },
            //         {
            //             path: 'shop-user-confirm',
            //             name: '门店账号确认',
            //             component: () => import('@/views/permission/ShopUserConfirm.vue'),
            //             meta: { title: '门店账号确认' }
            //         }
            //     ]
            // },
            // {
            //     path: 'role',
            //     name: '角色管理',
            //     component: () => import('@/views/permission/Index.vue'),
            //     meta: { title: '角色管理', hidden: true },
            //     children: [
            //         {
            //             path: 'list',
            //             name: '角色列表',
            //             component: () => import('@/views/permission/Role.vue'),
            //             meta: { title: '角色列表', keepAlive: true, depth: 30}
            //         },
            //         {
            //             path: 'edit',
            //             name: '角色编辑',
            //             component: () => import('@/views/permission/RoleEdit.vue'),
            //             meta: { title: '角色编辑', hidden: true },
            //         },
            //     ]
            // }
        ]
    }
]

export default permissionRouter